<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import Vue from 'vue';
  import UserNotificationMixin from '../../Mixins/800/userNotification.mixin';
  import AppBox from '@/components/app/box.vue';
  export default {
    mixins: [UserNotificationMixin],
    components: { AppBox },
    props: {
      id: {
        type: Number,
        default: 0,
      },
      missionPhoneMissionRank: {
        type: Number,
        default: 1,
      },
      creationDate: {
        type: String,
        default: '',
      },
      phoneCode: {
        type: Number,
        default: 0,
      },
      content: {
        type: String,
        default: '',
      },
      seen: {
        type: Boolean,
        default: false,
      },
      user: {
        type: Object,
      },
    },
    methods: {
      onChangeSeenStatus: function (title) {
        if (this.seen) this.setUserNotificationUnseen(this.id, title);
        else this.setUserNotificationSeen(this.id, title);
      },
    },
    computed: {
      iconColor: function () {
        switch (this.missionPhoneMissionRank) {
          case 1:
            return '#EBEBEB';
          case 2:
            return '#2EBA7F';
          case 3:
            return '#FFBD55';
          case 4:
            return '#DA6757';

          default:
            return '#EBEBEB';
        }
      },
      fullName: function () {
        const { firstName, lastName, userName } = this.user;
        return firstName && lastName ? `${firstName} ${lastName}` : userName;
      },
      jalaliCreationDate: function () {
        return Vue.moment(this.creationDate).format('jYYYY/jMM/jDD-HH:mm');
      },
    },
  };
</script>
<template>
  <app-box outlined :is-active="!seen" :is-disabled="seen">
    <div class="relative flex-gap-2 justify-between">
      <div class="flex-gap-2">
        <div class="d-flex gap-1 items-center">
          <v-icon dark :color="iconColor">mdi-ambulance mdi-16px</v-icon>
          <div class="phone-code">{{ phoneCode }}</div>
          <div></div>
        </div>
        <div class="content">{{ content }}</div>
      </div>
      <div class="absolute date-user-info flex-gap-2">
        <div>
          {{ fullName }}
        </div>
        <div>
          {{ jalaliCreationDate }}
        </div>
      </div>
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              color="darkColor"
              icon
              v-on="on"
              @click.stop="onChangeSeenStatus(content)"
              v-bind="attrs"
            >
              <v-icon>{{ seen ? 'mdi-email-open' : 'mdi-email' }} mdi-20px</v-icon>
            </v-btn>
          </template>
          <span>خوانده {{ seen ? 'شده' : 'نشده' }}</span>
        </v-tooltip>
      </div>
    </div>
  </app-box>
</template>
<style lang="scss">
  .content {
    font-weight: 600;
  }
  .date-user-info {
    position: absolute;
    right: 0;
    top: -15px;
  }
</style>
